import React from "react"
import { OpportunityModel } from "../../../models/supplier/OpportunityModel"
import { LoadingButton } from "@mui/lab"
import { colorGreen500, colorLight, colorPrimary, colorPrimaryDark, colorRed } from "../../../rsc/colors/colors"
import { useMutation } from "@apollo/client"
import { acceptOpportunity } from "../../../api/suppliers"
import { t } from "i18next"
import { SupplierOpportunity } from "../../../models/supplier/SupplierOpportunity"

type Props = {
    opportunity: OpportunityModel
    onAccept: (opp: SupplierOpportunity) => void
    onReject: () => void
}

export function OpportunityStatusButton({ opportunity, onAccept, onReject }: Props) {

    const statusStyle: React.CSSProperties = {
        background: opportunity.isRejected() ? colorRed() : colorGreen500,
        color: colorLight(),
        padding: 5,
        borderRadius: 5,
        textAlign: 'center'
    }

    const [mutate, { loading: loadingAccept, error }] = useMutation(acceptOpportunity, {
    })

    const acceptOffer = () => {
        mutate({
            variables: {
                opportunity_id: opportunity.id,
                accept: true
            },
            onCompleted: (d: any) => {
                onAccept(SupplierOpportunity.build(d.opp))
            }
        })
    }

    const rejectOffer = () => {
        mutate({
            variables: {
                opportunity_id: opportunity.id,
                accept: false
            },
            onCompleted: () => {
                onReject()
            }
        })
    }

    return (
        <div style={{ width: '100%', padding: '10px 10px 0 10px', borderTop: '1px solid grey' }}>
            {
                opportunity.isRejected() ?
                    <div className="pempem-flex-row-center">
                        <span className="bold" style={statusStyle}>{t('rejected')}</span>
                    </div>
                    :
                    opportunity.isAccepted() ?
                        <div className="pempem-flex-row-center">
                            <span className="bold" style={statusStyle}>{t('proceed_with_agent')}</span>
                        </div>
                        :
                        <div className="pempem-flex-col gap5" style={{ width: '100%', alignItems: 'center' }}>
                            <span className="bold" style={{ color: colorPrimary() }}>Are you interested?</span>
                            <div className="pempem-flex-row gap10" style={{ width: '100%' }}>
                                <LoadingButton loading={loadingAccept} onClick={acceptOffer} variant="contained" style={{ background: colorPrimaryDark(), flex: 1 }}>
                                    {t('yes')}
                                </LoadingButton>
                                <LoadingButton disabled={loadingAccept} onClick={rejectOffer} variant="contained" style={{ background: colorPrimaryDark(), flex: 1 }}>
                                    {t('no')}
                                </LoadingButton>
                            </div>
                        </div>
            }
        </div>
    )
}